export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!.@$%^&*_-]).{8,99}$/;
export const SIX_DIGIT_REGEX = /^\d{6}$/;
export const SINGLE_CHARACTER_REGEX = /.*[a-zA-Z0-9].*/;
export const SINGLE_DIGIT_REGEX = /^\d+$/;
export const VALID_DATE_REGEX = /^(19|20)\d\d([- /.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])$/;
export const NUMBER_REGEX = /^\d+$/;

